import { DownloadCircle02Icon } from "@porchpass/ui";
import { useParams } from "react-router-dom";
import { useWebClientApi } from "src/api";
import { downloadBlobFile } from "src/utils/downloadBlobFile";
import SplashPageLayout from "../layouts/SplashPageLayout";

const downloadButtonClassName =
  "flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-[40px] border border-[#005cd6] bg-gradient-to-b from-[#3c6ff4] to-[#3265ea] p-4 text-base text-white no-underline hover:outline hover:outline-4 hover:outline-[#1453f52e] active:outline active:outline-4 active:outline-[#1453f52e] [&_svg]:fill-white";

const DownloadSignedDocuments = () => {
  const { application_id, document_id } = useParams<{
    application_id: string;
    document_id: string;
  }>();
  const api = useWebClientApi();

  const handleDownloadPdf = async () => {
    if (!application_id || !document_id) return;

    const blob = await api.getApplicationDocument(application_id, document_id);
    downloadBlobFile(blob, `application-${application_id}.pdf`);
  };

  const handleDownloadArchive = async () => {
    if (!application_id || !document_id) return;

    const blob = await api.getApplicationDocumentArchive(
      application_id,
      document_id,
    );
    downloadBlobFile(blob, `application-${application_id}-documents.zip`);
  };

  return (
    <SplashPageLayout>
      <div className="text-base font-semibold text-[#1453f5]">
        Your documents are ready!
      </div>
      <p className="my-[10px] mb-6 text-base text-[#4a5466]">
        Grab your documents by clicking below.
      </p>

      <div className="flex flex-col items-center gap-[18px]">
        <button
          type="button"
          className={downloadButtonClassName}
          onClick={() => void handleDownloadPdf()}
        >
          Download Combined PDF{" "}
          <DownloadCircle02Icon size={18} className="text-white" />
        </button>

        <div className="flex h-10 items-center justify-center text-sm font-medium text-[#6b7280]">
          — or —
        </div>

        <button
          type="button"
          className={downloadButtonClassName}
          onClick={() => void handleDownloadArchive()}
        >
          Download Separate Documents{" "}
          <DownloadCircle02Icon size={18} className="text-white" />
        </button>
      </div>
    </SplashPageLayout>
  );
};

export default DownloadSignedDocuments;
